const state = {
  openDialogCall: false,
  isConnectedToSIP: JSON.parse(localStorage.getItem("sip")),
  isInCall: false,
  startDirectCall: false,
  numberToCall: null,
  queueToCall: null,
  fromCampaignsRegister: false,
};

const getters = {
  GET_IS_OPEN(state) {
    return state.openDialogCall;
  },
  GET_IS_CONNECTED(state) {
    return state.isConnectedToSIP;
  },
  GET_IS_IN_CALL(state) {
    return state.isInCall;
  },
  GET_START_DIRECT_CALL(state) {
    return state.startDirectCall;
  },
  GET_NUMBER_TO_CALLL(state) {
    return state.numberToCall;
  },
  GET_QUEUE_TO_CALL(state) {
    return state.queueToCall;
  },
  GET_IS_FOR_CAMPAIGNS_REGISTER(state) {
    return state.fromCampaignsRegister;
  },
};

const mutations = {
  TOGGLE_OPEN: (state) => (state.openDialogCall = !state.openDialogCall),
  TOGGLE_OPEN_AUTOFILL: (state, payload) => {
    state.openDialogCall = !state.openDialogCall;
    state.numberToCall = payload.number;
    state.queueToCall = payload.queueID;
  },
  TOGGLE_CONNECTED: (state) => (state.isConnectedToSIP = !state.isConnectedToSIP),
  SET_CONNECTED: (state, payload) => (state.isConnectedToSIP = payload),
  CHANGE_IS_IN_CALL: (state, payload) => (state.isInCall = payload),
  START_DIRECT_CALL: (state, payload) => {
    state.numberToCall = payload;
    state.startDirectCall = true;
  },
  STOP_DIRECT_CALL: (state) => {
    state.numberToCall = null;
    state.startDirectCall = false;
  },
  SET_IS_FOR_CAMPAIGNS_REGISTER: (state, payload) => {
    state.fromCampaignsRegister = payload;
  },
};

const actions = {
  TOGGLE_OPEN_DIALOG({ commit }) {
    try {
      commit("TOGGLE_OPEN");
    } catch (error) {
      return Promise.reject(error);
    }
  },
  TOGGLE_OPEN_DIALOG_AUTOFILL({ commit }, payload) {
    try {
      commit("TOGGLE_OPEN_AUTOFILL", payload);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  TOGGLE_IS_CONNECTED({ commit, state }) {
    try {
      localStorage.setItem("sip", !state.isConnectedToSIP);
      commit("TOGGLE_CONNECTED");
    } catch (error) {
      return Promise.reject(error);
    }
  },
  SET_IS_CONNECTED({ commit }, payload) {
    try {
      commit("SET_CONNECTED", payload);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  START_DIRECT_CALL({ commit }, payload) {
    commit("START_DIRECT_CALL", payload);
  },
  STOP_DIRECT_CALL({ commit }) {
    commit("STOP_DIRECT_CALL");
  },
  CHANGE_CALL_STATUS({ commit }, payload) {
    commit("CHANGE_IS_IN_CALL", payload);
  },
  CHANGE_IS_FOR_CAMPAIGNS_REGISTER({ commit }, payload) {
    commit("SET_IS_FOR_CAMPAIGNS_REGISTER", payload);
  },
};

// Exportar Clientes
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
